<template>
  <div id="app">
    <Header routeValue="4-2"></Header>
    <content class="help-result">
      <div :class="scroll>53?'banner_scroll':'banner_box'">
        <div class="search_section" :style="{marginTop:scroll>53?'72px':'100px'}">
           <span>
            <a-input
              placeholder="Search for answers"
              v-model="searchValue"
              @pressEnter="onSearch"
              allow-clear>
              <a-icon slot="prefix" type="search"/>
            </a-input>
          </span>
        </div>
      </div>
      <div class="container_des">
        <div class="content_box">
          <div style="width: 344px;margin-right: 20px">
            <div :class="scroll>53?'item_scroll':'item_view'">
              <div class="item_l" v-for="item in dataList">
                <a :href="item.prefix + item.link">
                  <div class="divider"></div>
                  <div class="title">
                    {{ item.name }}
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="item_view" :style="{marginTop:scroll>53?'240px':'' }">
            <div class="select_box">
              <div class="name">
                Results for {{ queryParam.searchContent !== '' ? '"' + queryParam.searchContent + '"' : 'all' }}
              </div>
              <div class="divider"></div>
            </div>
            <div class="item_r">
              <div class="item" v-for="item in articleList" v-if="articleList.length>0">
                <a class="title" :href="item.prefix + item.link">{{ item.title }}</a>
                <span class="des" v-html="item.desc"></span>
              </div>
              <div class="help_page" v-if="articleList.length>0">
                <a @click="changeSize(1)" v-if="!isFirstPage">< Previous page</a>
                <a @click="changeSize(2)" v-if="!isLastPage ">Next page ></a>
              </div>
              <div v-else>
                <p class="empty">
                  Sorry there are no search results for "{{ queryParam.searchContent }}"
                </p>
                <p class="empty">
                  Try rewording your query, or browse through the knowledge articles.
                </p>
              </div>
            </div>
          </div>

        </div>

      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import {get, post} from '@/api'
import {getSeoLinkName} from '@/utils/utils'

export default {
  name: 'HelpResult',
  components: {
    Header,
    Footer,
  },
  data () {
    return {
      link: '',
      scroll: 0,
      isFirstPage: false,
      isLastPage: false,
      dataList: [],
      articleList: [],
      searchValue: undefined,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        searchContent: undefined
      },
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll)
  },
  created () {
    this.queryParam.searchContent = this.$route.query.term
    this.searchValue = this.$route.query.term
    this.listHelpIndex()
    this.getArticleList()
  },
  methods: {
    handleScroll () {
      this.scroll = document.documentElement.scrollTop || document.body.scrollTop
    },
    listHelpIndex () {
      get('/merchant/message/help/index')
        .then(response => {
          this.dataList = response.data
          this.dataList.forEach(item => {
            item.link = getSeoLinkName(item.name)
            item.prefix = '/help/list/'
          })
        }).catch(error => {
        console.error(error)
      })

    },
    getArticleList () {
      window.scrollTo({top: 0, behavior: 'smooth'})
      post(`/merchant/message/help/search`, this.queryParam)
        .then(response => {
          this.isFirstPage = response.data.isFirstPage
          this.isLastPage = response.data.isLastPage
          this.articleList = response.data.list
          this.total = response.data.total
          this.articleList.forEach(item => {
            item.link = getSeoLinkName(item.title)
            item.prefix = '/help/details/'
          })
        }).catch(error => {
        console.error(error)
      })
    },
    onSearch (row) {
      if (!row.target.value) return
      this.queryParam.pageNum = 1
      this.queryParam.searchContent = row.target.value
      this.getArticleList()
    },
    changeSize: function (type) {
      this.type = type
      const maxNum = Math.ceil(this.total / this.queryParam.pageSize)
      switch (type) {
        // 首页
        case 0:
          this.queryParam.pageNum = 1
          break
        case 1:
          this.queryParam.pageNum -= 1
          break
        case 2:
          this.queryParam.pageNum += 1
          break
        case 3:
          this.queryParam.pageNum = maxNum
          break
      }
      if (this.queryParam.pageNum <= 0) {
        this.queryParam.pageNum = 1
      }
      if (this.queryParam.pageNum > maxNum) {
        this.queryParam.pageNum = maxNum
      }
      this.getArticleList()
    },
    adjustIframeSize () {
      const iframe = this.$refs.myIframe
      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document
      if (iframeDocument) {
        const body = iframeDocument.body
        const html = iframeDocument.documentElement
        const height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight)
        iframe.style.height = `${height}px`
      }
    },
  },
}
</script>
<style scoped lang="less">
.help-result {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  min-height: 855px;
  font-family: HarmonyOS Sans SC;

  .banner_scroll {
    width: 100%;
    height: 140px;
    background-image: url(../../assets/icon/banner_bg2.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    position: fixed;
    top: 20px;
    z-index: 100;
  }

  .banner_box {
    height: 190px;
    background-image: url(../../assets/icon/banner_bg1.jpg);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    //margin-top: 72px;
  }

  .search_section {
    width: 1052px;
    display: flex;
    flex-direction: column;
    margin-left: 425px;
    margin-top: 100px;

    /deep/ .ant-input {
      height: 50px;
      border-radius: 4px;
      font-size: 15px;
      font-weight: 400;
      background: #FFFFFF;
    }
  }

  .container_des {
    position: relative;
    width: 100%;
    max-width: 1052px;
    margin-left: 425px;
    float: none !important;
    display: flex;
    flex-wrap: wrap;

    .content_box {
      width: 100%;
      margin-top: 84px;
      display: flex;
      margin-bottom: 52px;

      .item_scroll {
        position: fixed;
        top: 170px;
      }

      .item_view {
        display: flex;
        flex-direction: column;
      }

      .item_l {
        width: 344px;
        margin-right: 20px;

        a:hover {
          .divider {
            width: 3px;
            height: 25px;
            background: #2D3E50;
          }
        }

        a {
          width: 240px;
          height: 40px;
          display: flex;
          align-items: center;
          cursor: pointer;

          .divider {
            width: 3px;
            height: 25px;
            background: transparent;
          }

          .title {
            font-weight: 400;
            font-size: 14px;
            color: #33475B;
            margin-left: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }

      .select_box {
        width: 688px;

        .name {
          font-weight: 500;
          font-size: 32px;
          color: #33475B;
          line-height: 40px;
        }

        .des {
          font-weight: 400;
          font-size: 14px;
          color: #33475B;
          margin-top: 10px;
        }

        .divider {
          height: 1px;
          background: #DFE3EB;
          margin: 26px 0 38px 0;
        }
      }

      .item_r {
        width: 688px;

        .item {
          display: flex;
          flex-direction: column;
          margin-bottom: 35px;

          a:hover {
            text-decoration: underline;
          }

          .title {
            display: inline-block;
            font-size: 18px;
            font-weight: bold;
            line-height: 28px;
            color: rgb(45, 62, 80);
          }

          .des {
            font-size: 16px;
            font-weight: 400;
            color: rgb(51, 71, 91);
            line-height: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;

          }
        }
      }

      .help_page {
        height: 40px;
        margin-top: 10px;
        display: flex;
        align-items: center;
        -webkit-user-select: none;

        a {
          font-size: 16px;
          color: #2D3E50;
          margin-right: 10px;
        }

        a:hover {
          text-decoration: underline;
        }

      }


      .empty {
        color: #33475B;
        font-size: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help/HelpResult.vue